var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 427.47 427.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M365.33,62.4c-83.2-83.2-219.73-83.2-302.93,0-83.2,83.2-83.2,219.73,0,302.93s217.6,83.2,300.8,0c85.33-83.2,85.33-219.73,2.13-302.93ZM171.2,320.53l-85.33-85.33,29.87-29.87,55.47,55.47L312,120l29.87,29.87-170.67,170.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.35e1399712a197ced5477c80ddabb79e.svg";
export { ForwardRef as ReactComponent };